import Collection from '../../utils/Collection';

import {
  FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SENT,
  FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED,
  FETCH_MY_LESSONS_WITH_OPEN_ISSUE_FAILED,
} from '../../actions/lesson';

import {
  REPORT_LESSON_ISSUE_SENT,
  REPORT_LESSON_ISSUE_SUCCEEDED,
  REPORT_LESSON_ISSUE_FAILED,
  RESOLVE_LESSON_ISSUE_SENT,
  RESOLVE_LESSON_ISSUE_SUCCEEDED,
  RESOLVE_LESSON_ISSUE_FAILED,
} from '../../actions/lessonIssue';

const initialState = {
  myLessons: [],
  myLessonsUpdatedAt: null,
  numOfLessons: 0,
  loading: false,
  loadedOnce: false,
  saving: false,
  page: 1,
};

export default function lessonWithIssueReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        loadedOnce: true,
        myLessons: Collection.reset(state.myLessons, payload.lessons),
        numOfLessons: payload.numOfLessons,
      };
    case FETCH_MY_LESSONS_WITH_OPEN_ISSUE_SENT:
      return {
        ...state,
        loading: true,
        page: payload.page,
      };
    case FETCH_MY_LESSONS_WITH_OPEN_ISSUE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case REPORT_LESSON_ISSUE_SENT:
    case RESOLVE_LESSON_ISSUE_SENT:
      return {
        ...state,
        saving: true,
      };
    case REPORT_LESSON_ISSUE_SUCCEEDED:
      return {
        ...state,
        saving: false,
        myLessons: Collection.add(state.myLessons, payload.lesson),
        myLessonsUpdatedAt: new Date(),
      };
    case RESOLVE_LESSON_ISSUE_SUCCEEDED:
      return {
        ...state,
        saving: false,
        myLessons: Collection.remove(state.myLessons, payload.lesson),
        myLessonsUpdatedAt: new Date(),
      };
    case REPORT_LESSON_ISSUE_FAILED:
    case RESOLVE_LESSON_ISSUE_FAILED:
      return {
        ...state,
        saving: false,
      };
    default:
      return state;
  }
}
